import CascaderSingle from './Index.vue'

CascaderSingle.install = function(Vue) {
  Vue.component(CascaderSingle.name, CascaderSingle)
}

export default CascaderSingle
